export default __webpack_public_path__ + "static/media/36I-117133_-37269_0.b37a2730.jpg";